import { queryClient } from '../../../config/queryClient';

const queryKeyIncludesClient = (queryKey: unknown, clientId: number): boolean => {
  if (!Array.isArray(queryKey)) {
    return false;
  }

  const clientIdStr = String(clientId);

  return queryKey.some(key => key === clientId || key === clientIdStr);
};

/**
 * Refetches cached react-query data for the target client and reloads the
 * legacy financial plan after a PDF reconciliation apply completes.
 */
export const refreshClientDataAfterPdfImport = async (clientId: number): Promise<void> => {
  await queryClient.refetchQueries({
    predicate: ({ queryKey }) => queryKeyIncludesClient(queryKey, clientId),
  });

  const refresh = ADV.NewFinancialPlan;

  if (refresh?.refreshPlan) {
    refresh.refreshPlan(true);
  }
};
